
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'


export default {
data() {
return {
buttonText: '获取验证码',
SmsCode: '',
mobile: '',
newpasswdone: '',
newpasswdtwo: '',
aa: '',
smsDisabled: false
}
},
components: {
Group,
XInput,
XButton
},
methods: {
getcode() {
var that = this
var obj = {
nationcode: '86',
mobile: this.mobile
}
if (this.mobile) {
this.$http.post('/api/v1/accounts/sms', obj)
.then(function (response) {
that.aa = response.data.data
if (response.data.result === 0) {
var validateCode = {
timestamp: parseInt(new Date().getTime() / 1000),
code: response.data.data
}
localStorage.setItem('validateCode', JSON.stringify(validateCode))
} else {
that.$vux.alert.show({
title: '',
content: response.data.errmsg
})
}
})
localStorage.setItem('countDown', 60)
that.timeKeeping()
}
},
changepassword() {
var newUserInfo = {
passwd: this.newpasswdtwo
}
var that = this
if (this.newpasswdone !== this.newpasswdtwo) {// 新密码不一致
this.$vux.toast.show({
text: "密码不一致,请重新输入",
type: "cancel",
time: "1000"
})
} else { // 新密码一致
this.$http.put('/api/v1/accounts/' + this.mobile + '/checksms', {
code: this.SmsCode,
passwd: this.newpasswdtwo
}).then(res => {
that.$vux.toast.show({
text: "修改成功",
type: "success",
time: "1000"
});
that.$router.push({path: "login"});
}).catch(error => {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
})

}


},
timeKeeping() {
this.smsDisabled = true
var app = this
var interval = setInterval(function () {

var countDown = parseInt(localStorage.getItem('countDown'))

app.buttonText = countDown + '秒'

if (countDown === 0) {
clearInterval(interval)
localStorage.removeItem('countDown')
app.buttonText = '重新发送'
app.smsDisabled = false
} else {
countDown--
localStorage.setItem('countDown', countDown)
}
}, 1000)
}
}
}



// WEBPACK FOOTER //
// ./src/components/forgetpassword.vue